import { Injectable } from "@angular/core";
import { HttpClient} from '@angular/common/http';
import { Observable } from "rxjs";
import { ShareStudyAreaRequest } from "../interfaces/share-study-area-request";
import { DfpSpecialist, DfpSpecialistRequest } from "../interfaces/dfpspecialist";


@Injectable({
  providedIn: 'root'
})

export class StudyAreaAccessService {
  apiBase: string = '/api/StudyAreas';
  constructor(private readonly httpClient: HttpClient) {
  }

  updateAccess(shareStudyAreaRequest: ShareStudyAreaRequest): Observable<void> {
  const url:string = `${this.apiBase}/shared`;
  return this.httpClient.patch<void>(url, shareStudyAreaRequest);
}

  getAllDfpSpecialists(): Observable<DfpSpecialist[]> {
     const url:string = `${this.apiBase}/dfpSpecialists`;
    return this.httpClient.get<DfpSpecialist[]>(url);
  }
   updateDfpSpecialists(request: DfpSpecialistRequest): Observable<void> {
      const url:string = `${this.apiBase}/shared`;
      return this.httpClient.patch<void>(url, request);
    }    

}
